import { StoreFrontOptionsDefaultViewEnum } from '@b-stock/listing-api-client'

import {
  type DateRange,
  type Range,
} from '@/components/listings/search/SearchFilters/shared/commonTypes'

import type { SupportedQueryParam } from './types'
import { SUPPORTED_QUERY_PARAMS } from './types'

export const isRange = (filterState: unknown): filterState is Range =>
  Array.isArray(filterState) &&
  filterState.length === 2 &&
  (filterState[0] === null || typeof filterState[0] === 'number') &&
  (filterState[1] === null || typeof filterState[1] === 'number')

export const isDateRange = (filterState: unknown): filterState is DateRange =>
  Array.isArray(filterState) &&
  filterState.length === 2 &&
  (filterState[0] === null || typeof filterState[0] === 'string') &&
  (filterState[1] === null || typeof filterState[1] === 'string')

export const isStringList = (filterState: unknown): filterState is string[] =>
  Array.isArray(filterState) && filterState.every((x) => typeof x === 'string')

export const isView = (
  value: unknown
): value is StoreFrontOptionsDefaultViewEnum =>
  (Object.values(StoreFrontOptionsDefaultViewEnum) as unknown[]).includes(value)

export const isSupportedQueryParam = (
  key: string
): key is SupportedQueryParam =>
  SUPPORTED_QUERY_PARAMS.includes(key as SupportedQueryParam)
